<template>
  <div>
    <el-table :data="list">
      <el-table-column label="材料分类" align="center" prop="category">
        <template slot-scope="scope">
          {{
            CommodityCategoryMap.filter(
              (item) => item.id == scope.row.category
            )[0].name
          }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" prop="order.number" align="center">
      </el-table-column>
      <el-table-column label="供货单位" prop="order.supplier" align="center">
      </el-table-column>
      <el-table-column label="入库日期" align="center" min-width="100">
        <template slot-scope="scope">
          {{ $time(scope.row.order.stock_time).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        label="入库单号"
        prop="order.stockin_number"
        align="center"
      >
      </el-table-column>
      <!-- <el-table-column label="部门" prop="order.department" align="center">
      </el-table-column>
      <el-table-column label="业务员" prop="order.saler" align="center">
      </el-table-column> -->
      <el-table-column label="名称" prop="name" align="center">
      </el-table-column>
      <el-table-column label="存货编码" prop="code" align="center">
      </el-table-column>
      <el-table-column label="规格" prop="specification" align="center">
      </el-table-column>
      <el-table-column label="型号/倒角" prop="model_number" align="center">
      </el-table-column>
      <el-table-column label="计量单位" prop="unit" align="center">
      </el-table-column>
      <el-table-column label="数量" prop="number" align="center">
      </el-table-column>
      <el-table-column label="无税单价" prop="no_tax_price" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.no_tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="含税单价" prop="tax_price" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="无税金额" prop="no_tax_price" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.total_no_tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税额" prop="no_tax_price" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.total_tax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="价税合计" prop="no_tax_price" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.total_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { CommodityCategoryMap } from '../../../config/global'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      CommodityCategoryMap,
    }
  },
}
</script>